var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        { staticClass: "vh-100 justify-content-center align-items-center" },
        [
          _c(
            "b-col",
            { attrs: { sm: "12", md: "10", lg: "8" } },
            [
              _c(
                "b-card",
                { staticClass: "rounded-0" },
                [
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "div",
                        { staticClass: "form-header" },
                        [
                          _c(
                            "b-link",
                            {
                              attrs: {
                                href: "https://artenara.es/portal-ciudadano/"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "form-header_logo img-fluid",
                                attrs: {
                                  src: require("../assets/ayto-artenara-logo.jpg"),
                                  alt: "Logo del Ayuntamiento de Artenara"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onSubmit($event)
                            }
                          }
                        },
                        [
                          _c("h1", { staticClass: "form-title" }, [
                            _vm._v("Verificación de Certificado de Viajes")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-alert",
                            {
                              attrs: {
                                show: _vm.dismissCountDown,
                                fade: "",
                                variant: "danger"
                              },
                              on: { "dismiss-count-down": _vm.countDownChanged }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errorMessage) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-body" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-lg-12" },
                                [
                                  _c(
                                    "b-form-group",
                                    { staticClass: "required" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "control-label",
                                          attrs: { for: "csv" }
                                        },
                                        [
                                          _vm._v(
                                            "Código Seguro de Verificación"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "csv",
                                          state: _vm.validateState("csv"),
                                          "aria-describedby": "csv",
                                          autocomplete: "off"
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.$v.form.csv.$touch()
                                          }
                                        },
                                        model: {
                                          value: _vm.$v.form.csv.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.csv,
                                              "$model",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "$v.form.csv.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        { attrs: { id: "csv" } },
                                        [
                                          !_vm.$v.form.csv.required
                                            ? _c("p", [
                                                _vm._v(
                                                  "\n                        Debe introducir el Código Seguro de Verificación asociado al certificado.\n                      "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-center" },
                                    [
                                      _c("vue-recaptcha", {
                                        ref: "recaptcha",
                                        staticClass: "g-recaptcha",
                                        attrs: {
                                          sitekey:
                                            "6LdBHxcpAAAAAOxsQ-1dJHRCtNRSbxnPTguPNxY5",
                                          loadRecaptchaScript: true
                                        },
                                        on: {
                                          verify: _vm.verifyRecaptcha,
                                          expired: _vm.expiredRecaptcha,
                                          error: _vm.errorRecaptcha
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-center" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            type: "submit",
                                            variant: "primary",
                                            disabled: _vm.$v.$invalid
                                          }
                                        },
                                        [
                                          _vm.loading
                                            ? _c("b-spinner", {
                                                staticClass: "mr-2",
                                                attrs: { small: "" }
                                              })
                                            : _vm._e(),
                                          _vm.loading
                                            ? _c("span", [
                                                _vm._v(
                                                  "Verificando certificado"
                                                )
                                              ])
                                            : _c(
                                                "span",
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      icon: ["fas", "file"]
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "Verificar certificado"
                                                  )
                                                ],
                                                1
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { variant: "danger" },
                                          on: { click: _vm.resetForm }
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "mr-2",
                                                attrs: { icon: ["fas", "undo"] }
                                              }),
                                              _vm._v("Borrar todo")
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            to: { name: "GenerateCertificate" },
                                            variant: "info"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  icon: ["fas", "arrow-left"]
                                                }
                                              }),
                                              _vm._v("Volver")
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-footer" })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-343e14d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-343e14d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/VerifyCertificate.vue
// module id = null
// module chunks = 